import Vue from 'vue'
// 基础UI组件库
import './mixins'
// 第三方组件库
import Toast from 'vue2-toast'
import 'vue2-toast/lib/toast.css';
// 自定义组件库
import KktGesture from './KktGesture'
import KktDatePicker from './KktDatePicker'
import KktTimeSelect from './KktTimeSelect'
// 注册自定义组件

import NewDatePicker from './NewDatePicker'
import Modal from './Modal'
import Page from './Page'

// 自定义指令
import rebound from './directives/rebound'

var mixinObj = {
  'NewDatePicker': NewDatePicker,
  'KktGesture': KktGesture,
  'KktDatePicker': KktDatePicker,
  'KktTimeSelect': KktTimeSelect,
  'Modal': Modal,
  'Page': Page
}

for (var key in mixinObj) {
  Vue.component(key, mixinObj[key])
}

// 注册第三方组件库
Vue.use(Toast, {
  defaultType: 'center',
  duration: 2000,
  wordWrap: true,
  width: '150px'
})

// 注册自定义指令
Vue.directive('rebound', rebound)



// WEBPACK FOOTER //
// ./src/components/index.js